<template>
  <div class="admin-content">
    <router-view></router-view>
  </div>
</template>

<script>
// import { BTabs, BTab } from "bootstrap-vue";
// import Acronyms from "@/views/admin/acronyms/Acronyms.vue";
// import Contact from "@/views/admin/contact/Contact.vue";
// import Hat from "@/views/admin/hats/Hat.vue";
// import Origin from "@/views/admin/origins/Origin.vue";
// import PushConfig from "@/views/admin/push-config/PushConfig.vue";
// import Subject from "@/views/admin/subjects/Subject.vue";
// import Subscribers from "@/views/admin/subscribers/Subscribers.vue";
// import Tag from "@/views/admin/tags/Tag.vue";
// import UserClient from "@/views/admin/user-client/UserClient.vue";
// import UserHeader from "@/views/admin/user-header/UserHeader.vue";
// import User from "@/views/admin/users/User.vue";
// import Periodicity from "@/views/admin/periodicity/Periodicity.vue";
// import Characteristic from "@/views/admin/characteristic/Characteristic.vue";
// import Package from "@/views/admin/package/Package.vue";
// import Language from "@/views/admin/language/Language.vue";
// import Country from "@/views/admin/country/Country.vue";
// import ContentPage from "@/views/admin/content/Content.vue";
// import Commodity from "@/views/admin/commodity/Commodity.vue";
// import ReportType from "@/views/admin/reportType/ReportType.vue";
// import Channel from "@/views/admin/channel/Channel.vue";
// import { ref } from "@vue/composition-api";

export default {
  components: {
    // BTabs,
    // BTab,
    // Acronyms,
    // Contact,
    // Hat,
    // Origin,
    // PushConfig,
    // Subject,
    // Subscribers,
    // Tag,
    // UserClient,
    // UserHeader,
    // User,
    // Periodicity,
    // Characteristic,
    // Package,
    // Language,
    // Country,
    // ContentPage,
    // Commodity,
    // ReportType,
    // Channel,
  },
  watch: {
    // currentTab(val) {
    //   //   router.replace({ query: currentRouteQuery }).catch(() => {});
    //   this.$router.push({
    //     name: this.tabRouter.find((item) => item.index == val).route,
    //   });
    // },
  },
  created() {
    // this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", true);
    // this.$router.push({name: this.tabRouter[0].route});
  },
  setup() {
    // const currentTab = ref(0);
    // const tabRouter = ref([
    //   { index: 0, route: "admin-subscribers" },
    //   { index: 1, route: "admin-subject" },
    //   { index: 2, route: "admin-user-header" },
    //   { index: 3, route: "admin-hat" },
    //   { index: 4, route: "admin-contact" },
    //   { index: 5, route: "admin-origin" },
    //   { index: 6, route: "admin-push-config" },
    //   { index: 7, route: "admin-acronyms" },
    //   // { index: 8, route: "pages-synchronize" },
    //   { index: 8, route: "admin-tag" },
    //   { index: 9, route: "admin-user-client" },
    //   { index: 10, route: "admin-user" },
    //   { index: 11, route: "admin-commodity" },
    //   { index: 12, route: "admin-content" },
    //   { index: 13, route: "admin-package" },
    //   { index: 14, route: "admin-characteristic" },
    //   { index: 15, route: "admin-periodicity" },
    //   { index: 16, route: "admin-country" },
    //   { index: 17, route: "admin-language" },
    //   { index: 18, route: "admin-reportType" },
    //   { index: 19, route: "admin-channel" },
    // ]);

    return {
      // currentTab,
      // tabRouter,
    };
  },
};
</script>

<style>
</style>